<template>
  <div>
    <a-card title="新人奖励管理" :bordered="false">
      <a-table
          :columns="columns"
          :data-source="dataSource"
          :pagination="pagination"
          :loading="loading"
          row-key="id"
          @change="handleTableChange"
      >
        <span slot="isEnabled" slot-scope="text, record">
          <a-switch
              :checked="record.isEnabled === 1"
              @change="onToggle(record)"
              checked-children="开"
              un-checked-children="关"
          />
        </span>

        <span slot="action" slot-scope="text, record">
          <a @click="onEdit(record)">修改</a>
        </span>
      </a-table>
      <a-modal
          v-model="modalVisible"
          title="修改奖励配置"
          @ok="onSubmit"
          okText="确定"
          cancelText="取消"
      >
        <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
          <a-form-item label="奖励金币">
            <a-input-number v-model="form.rewardCoins" :min="0" />
          </a-form-item>
        </a-form>
      </a-modal>

    </a-card>
  </div>
</template>

<script>
import { getRegistrationPage ,editRegistration} from "@/api/recharge/newUserRecharge"; // 你需要实现这个API调用

export default {
  data() {
    return {
      loading: false,
      dataSource: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条`,
        showQuickJumper: true,
      },
      columns: [
        {
          title: "序号",
          dataIndex: "index",
          customRender: (text, record, index) => index + 1,
        },
        {
          title: "奖励类型",
          dataIndex: "rewardCoins",
          customRender: (text) => `金币 ${text}`,
        },
        {
          title: "是否启用",
          dataIndex: "isEnabled",
          scopedSlots: { customRender: "isEnabled" },
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: "action" },
        },
      ],
      modalVisible: false,
      currentRecord: {},
      form: {
        rewardCoins: 0,
      },
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      const { current, pageSize } = this.pagination;
      getRegistrationPage({ pageNum: current, pageSize: pageSize }).then((res) => {
        if (res.success) {
          this.dataSource = res.data.records;
          this.pagination.total = res.data.total;
        }
        this.loading = false;
      });
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.loadData();
    },
    // 开启/关闭状态
    onToggle(record) {
      const updated = {
        id: record.id,
        isEnabled: record.isEnabled === 1 ? 0 : 1,
        rewardCoins: record.rewardCoins,
      };
      editRegistration(updated).then(() => {
        this.$message.success("状态更新成功");
        this.loadData();
      });
    },
    // 弹出编辑框
    onEdit(record) {
      this.currentRecord = { ...record };
      this.form.rewardCoins = record.rewardCoins;
      this.modalVisible = true;
    },
    // 提交编辑
    onSubmit() {
      const payload = {
        id: this.currentRecord.id,
        rewardCoins: this.form.rewardCoins,
        isEnabled: this.currentRecord.isEnabled,
      };
      editRegistration(payload).then(() => {
        this.$message.success("修改成功");
        this.modalVisible = false;
        this.loadData();
      });
    },
  },
};
</script>
